import { useAuthUser } from "~~/app/composables/useAuthUser";

// Единая точка правды: кому доступны корзина и цены.
// Настройка «Видимость магазина» из админки открывает их всем посетителям,
// иначе — только вошедшим покупателям (USER) и сотрудникам (ADMIN, MANAGER).
export const useShopAccess = () => {
  const authUser = useAuthUser();
  const shopConfig = useShopConfig();

  return computed(() => {
    if (shopConfig.value.cart_public) return true;
    if (!authUser.value) return false;
    return (
      authUser.value.roles.includes("ADMIN") ||
      authUser.value.roles.includes("MANAGER") ||
      authUser.value.roles.includes("USER")
    );
  });
};
